export const palette = {
    mode: 'light',
    primary: {
        contrastText: '#fff',
        dark: '#0F4669',
        light: '#14D79D',
        main: '#2AA1E0',
    },
    secondary: {
        main: '#ff6d8f',
        gray: '#edf0f8',
        text: '#000000',
    },
};

export const components = (theme) => ({
    components: {
        ...theme.components,
        MuiButton: {
            ...theme.components.MuiButton,
            styleOverrides: {
                root: {
                    ...theme.components.MuiButton.styleOverrides.root,
                    boxShadow: 'none',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    '.MuiPaper-root': {
                        boxShadow: '0px 0 0 1px rgb(255 255 255 / 12%)',
                    },
                    '.MuiDialogContent-root': {
                        borderBottom: 0,
                    },
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    ...theme.components.MuiBackdrop.styleOverrides.root,
                    background: [`rgb(0 0 0 / 69%)`],
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    '> .MuiPaper-root': {
                        boxShadow: theme.shadows[0],
                    },
                },
            },
        },
    },
});
